import http from "../http-common";
import { Section } from "../models/sectionModel";

class SectionDataService {
  async createSection(section: Section) {
    const json = JSON.stringify(section);
    return await http.post("/sections/create", json);
  }

  async updateSection(section: Section) {
    const json = JSON.stringify(section);
    return await http.post("/sections/update", json);
  }

  async deleteSections(sections: Section[]) {
    const json = JSON.stringify(sections);
    return await http.post("/sections/delete", json);
  }
  
  async moveSections(sections: Section[]) {
    const json = JSON.stringify(sections);
    return await http.post("/sections/move", json);
  }

  async copySections(sections: Section[]) {
    const json = JSON.stringify(sections);
    return await http.post("/sections/copy", json);
  }
}

export default new SectionDataService();